import { ModuleConstants } from '@hrms/common/constant/modules';
import { ComponentsMap } from '@hrms/common/routes/components';
import { ScreenNames } from '@hrms/common/routes/screens';
import { ModuleRoutesComponentInterface } from '@hrms/common/routes/types';
import { generateImage } from '@hrms/common/utils/generateImage';

const leavesBaseRoute = '/leaves';
const getLeaveRoutes: ModuleRoutesComponentInterface = () => {
  return [
    {
      id: ModuleConstants.LEAVES,
      route: leavesBaseRoute,
      title: ScreenNames.LEAVES,
      icon: generateImage({
        noScale: true,
        name: 'calendar',
        alt: 'config',
        className: 'w-4 h-4',
      }),
      component: null,
      children: [
        {
          id: ModuleConstants.HOLIDAY_CONFIGURATIONS,
          route: `${leavesBaseRoute}/holiday-configurations`,
          title: ScreenNames.HOLIDAY_CONFIGURATIONS,
          component: ComponentsMap.HOLIDAY_CONFIGURATIONS,
        },
        {
          id: ModuleConstants.LEAVE_CONFIGURATIONS,
          route: `${leavesBaseRoute}/leave-configurations`,
          title: ScreenNames.LEAVE_CONFIGURATIONS,
          component: ComponentsMap.LEAVE_CONFIGURATIONS,
        },
      ],
    },
  ];
};

export default getLeaveRoutes;
